import { toast } from '@zerodevx/svelte-toast';
import { toast_message } from './toast_message.js';


export function json(response) {
	return response.json()
}

export function getToken() {
	const auth_type = localStorage.getItem('HoyToKenTy');
	const auth_token = localStorage.getItem('HoyToKenTo');
	const domain_code = localStorage.getItem('HoyDoMainCode');
	return { auth_type, auth_token, domain_code };
}

export async function doFetch(url, method, payload, headers) {
	const turl = url;
	let theaders = { 'Content-Type': 'application/json' };
	if(headers !== undefined) {
		theaders = headers;
	}
	let requestOptions = {
		method: method,
		headers: theaders
	};        

	if(method === 'POST' && payload !== undefined) {
		requestOptions.body = JSON.stringify(payload);
	}

	const jdata = await fetch(turl, requestOptions)
	.then(json)
	.then(function (data) {
		if (!turl.includes('/auth/user') && data['detail'] && (data['detail'].toLowerCase().includes('expired') || data['detail'].toLowerCase().includes('credentials') || data['detail'].toLowerCase().includes('unauthorized')) && !window.location.href.includes('Contenthomepage/free')) {
			// window.location.href = '/';
		}
		return data;
	})
	.catch(function (error) {
		console.log('Request failed', error);
		const res = {"st": false, "msg": error};
		return res;
	});
	return jdata;
}

export async function doAPIPost(api_endpoint, busy_message, success_message, payload, headers={ 'Content-Type': 'application/json' }, duration=5000) {
	// toast_message(true, `${busy_message}, please wait...`, duration);

	const jdata = await doFetch(api_endpoint, 'POST', payload, headers);

	toast_message(jdata.status, jdata.msg, 3000);
	return jdata.status;
}

export async function doAddressSearch(api_host, address_query) {
	let res = {st: "false", msg: "Unknown error searching address"};
	const toast_id = toast.push('Searching for address, please wait...', {
		duration: 5000,
		// initial: 0,
		// progress: 0,
		dismissable: false,
		theme: {
			'--toastBackground': '#48BB78',
			'--toastProgressBackground': '#2F855A'
		}
	});

	const turl = api_host + "/api/ex/property_info";
	const payload = {q: address_query};
	const jdata = await doFetch(turl, 'POST', payload);
	toast.pop(toast_id);

	if (jdata.st) {
		res = jdata;
	} else {
		toast.push(jdata.msg, {
			duration: 5000,
			// initial: 0,
			// progress: 0,
			dismissable: false,
			theme: {
				'--toastBackground': '#F56565',
				'--toastProgressBackground': '#C53030'
			}
		});
	}

	return res;
}